import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function surveyModel() {
  const fetchSurveyListModel = reactive({
    api: apiEndpoint.bcrm_platform + "/survey/List",
    method: "POST",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [{ Seq: 1, Key: "progress", Direction: "DESC" }],
    },
  });

  const fetchSurveyDeleteModel = reactive({
    api: apiEndpoint.bcrm_platform + "/survey/Delete",
    method: "POST",
    payload: {
      Survey_GroupId: 1,
    },
  });

  const chagneStatusToggle = reactive({
    api: apiEndpoint.bcrm_platform + "/survey/ChangeStatus",
    method: "POST",
    payload: {
      Survey_GroupId: 1,
      Status: 1, //Active = 1 / Inactive = 2
    },
  });

  const createSurveyModel = reactive({
    api: apiEndpoint.bcrm_platform + "/survey/Create",
    method: "POST",
    payload: {
      Infomation: {
        Title: "",
        Survey_Name: "",
        Survey_Desc: "",
        Cover_Image_Url: "",
        Display_Image_Url: "",
        Status: 1,
        Valid_From: "",
        Valid_Through: "",
      },
      SetQuestion: [
        {
          SectionId: "",
          // Seq: "",
          Section_Name: "",
          Section_Desc: "",
          // NextStep_Type: "",
          // Next_SectionId: "",
          Question: [
            {
              QuestionId: "",
              Ques_Name: "",
              Ques_Desc: "",
              Input_Type: "",
              Choice_Mode: "",
              Ques_Image_URL: "",
              IsRequired: false,
              // NextStep_Type: "",
              // Next_SectionId: "",
              // Next_QuestionId: "",
              Option: [
                {
                  // OptionId: "",
                  Option: "",
                  Option_Image_Url: "",
                },
              ],
            },
          ],
        },
      ],
    },
  });

  const editSurveyModel = reactive({
    api: apiEndpoint.bcrm_platform + "/survey/Edit",
    method: "POST",
    payload: {
      Survey_GroupId: 1,
      Infomation: {
        Title: "",
        Survey_Name: "",
        Survey_Desc: "",
        Cover_Image_Url: "",
        Display_Image_Url: "",
        Status: 1,
        Valid_From: "",
        Valid_Through: "",
      },
      SetQuestion: [
        {
          SectionId: "",
          // Seq: "",
          Section_Name: "",
          Section_Desc: "",
          // NextStep_Type: "",
          // Next_SectionId: "",
          Question: [
            {
              // QuestionId: "",
              Ques_Name: "",
              Ques_Desc: "",
              Input_Type: "",
              Choice_Mode: "",
              Ques_Image_URL: "",
              IsRequired: false,
              // NextStep_Type: "",
              // Next_SectionId: "",
              // Next_QuestionId: "",
              IsDeleteImage: false,
              Option: [
                {
                  // OptionId: "",
                  Option: "",
                  Option_Image_Url: "",
                  IsDeleteImage: false,
                },
              ],
            },
          ],
        },
      ],
      Permission: {
        IsLimit: false,
        Tag: [
          {
            Tag_Type: 1,
            Tag_Name: "",
          },
        ],
      },
      Privilege: {
        Privilage_Type: 1,
        Criteria_Type: 1,
        Reward: [
          {
            Survey_PrivilegeId: "",
            PermissionId: "",
            TagId: "",
            InventoryId: "",
            PrivilegeId: "",
            Point: "",
          },
        ],
      },
      Score: {
        IsResult: false,
        SetScore: [
          {
            QuestionId: "",
            OptionId: "",
            Scores: "",
          },
        ],
        SetResult: [
          {
            ResultId: "",
            Scores_min: "",
            Scores_max: "",
            Title: "",
            Description: "",
            Note: "",
            Cover_Image_Url: "",
            Detail_HtmlEditor_Th: "",
            Detail_HtmlEditor_En: "",
            IsDeleteImage: false,
          },
        ],
      },
    },
  });

  const fetchDetailSurveyModel = reactive({
    api: apiEndpoint.bcrm_platform + "/survey/Detail",
    method: "POST",
    payload: {
      Survey_GroupId: 1,
    },
  });

  const deleteSectionModel = reactive({
    api: apiEndpoint.bcrm_platform + "/survey/DeleteSection",
    method: "POST",
    payload: {
      Survey_GroupId: 1,
      SectionId: 1,
    },
  });

  const deleteQuestionModel = reactive({
    api: apiEndpoint.bcrm_platform + "/survey/DeleteQuestion",
    method: "POST",
    payload: {
      Survey_GroupId: 1,
      SectionId: 1,
      QuestionId: 5,
    },
  });

  const mergeSectionModel = reactive({
    api: apiEndpoint.bcrm_platform + "/survey/MergeSection",
    method: "POST",
    payload: {
      Survey_GroupId: 1,
      Curent_SectionId: 5,
      Goto_SectionId: 1,
    },
  });

  const moveSectionModel = reactive({
    api: apiEndpoint.bcrm_platform + "/survey/MoveSection",
    method: "POST",
    payload: {
      Survey_GroupId: 1,
      MoveSection: [
        {
          SectionId: 5,
        },
        {
          SectionId: 1,
        },
      ],
    },
  });

  const fetchQueryDisplayDashboard = reactive({
    api: apiEndpoint.bcrm_platform + "/SurveyDashboard/Display",
    method: "POST",
    payload: {
      Survey_GroupId: 0,
    },
  });

  const fetchQueryDataDashboard = reactive({
    api: apiEndpoint.bcrm_platform + "/SurveyDashboard/Query",
    method: "POST",
    payload: {
      CardId: "",
      Survey_GroupId: null,
      QuestionId: null,
      Key: "",
    },
  });

  return {
    fetchSurveyListModel,
    fetchSurveyDeleteModel,
    chagneStatusToggle,
    createSurveyModel,
    editSurveyModel,
    fetchDetailSurveyModel,
    deleteSectionModel,
    deleteQuestionModel,
    mergeSectionModel,
    moveSectionModel,
    fetchQueryDisplayDashboard,
    fetchQueryDataDashboard,
  };
}
